export const DEFAULT_PAGE_OPTIONS=[5,10,25,50]
export const BIG_PAGE_OPTIONS=[50,100,250,500]